// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"12a5438e","787":"a542a446","792":"36a43251"}[chunkId] + ".chunk.js";
};